import { useAuth } from '@redtrack/auth-core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getEnvAction } from 'src/views/auth/features/userSlice';
import { loadAllPlans } from 'src/app/features/plansSlice';
import authService from 'src/services/authService';

export const useInitData = () => {
  const dispatch = useDispatch();

  const { isAuthenticated, logout: onLogout } = useAuth();

  const [shouldLoad, setShouldLoad] = useState(isAuthenticated);

  useEffect(() => {
    authService.setAxiosInterceptors({ onLogout });
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    setShouldLoad(false);

    Promise.all([
      dispatch(getEnvAction({})).unwrap(),
      dispatch(loadAllPlans({})).unwrap(),
    ]).catch(() => {
      console.error('Failed to load init data.');
      setShouldLoad(isAuthenticated);
    });
  }, [isAuthenticated, shouldLoad]);
};
